import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=53e94ed0&scoped=true&"
import script from "./VendorDetail.vue?vue&type=script&lang=js&"
export * from "./VendorDetail.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&id=53e94ed0&lang=scss&scoped=true&"
import style1 from "./VendorDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e94ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e94ed0')) {
      api.createRecord('53e94ed0', component.options)
    } else {
      api.reload('53e94ed0', component.options)
    }
    module.hot.accept("./VendorDetail.vue?vue&type=template&id=53e94ed0&scoped=true&", function () {
      api.rerender('53e94ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/vendors/VendorDetail.vue"
export default component.exports